import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import IconButton from '@material-ui/core/IconButton';
import InCallIcon from '../icons/InCallIcon';
import ShareIcon from '../icons/ShareIcon';
import CardButton from './CardButton';
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../other/translate.json';
import mail from '../other/config.json';
import AbortRecall from '../components/AbortRecall';
import axios from 'axios';
import Avatar from '@material-ui/core/Avatar';
import Snackbar from '@material-ui/core/Snackbar';
import clsx from 'clsx';
import KloStatus from '../components/KloSatus';
import config from '../other/config';
import PrimaryButton from './PrimaryButton';
import FavoriteButton from './Favorites/FavoriteButton';
import utils from '../other/utils';
const { serverAPI } = config;


// ===== ОТЛОЖЕНО НА ЭТАП 2 ================
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import CustomCheckboxWhite from "./CustomCheckboxWhite";
// import HintIcon from '../icons/HintIcon';
// ================ ОТЛОЖЕНО НА ЭТАП 2 =====

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.8)',
    color: '#FFFFFF',
    boxShadow: 'none',
    padding: 12,
    borderRadius: 8,
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
}))(Tooltip);

const CustomIconButton = withStyles((theme) => ({
  root: {
    // color: theme.palette.getContrastText(purple[500]),
    // backgroundColor: purple[500],
    color: '#BCBBD0',
    backgroundColor: '#FFFFFF',
    boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)',
    marginLeft: 8,
    // '&:hover': {
    //   backgroundColor: purple[700],
    // },
  },
}))(IconButton);

export default function AppInsideCard(props) {
  // console.log(props, +props.price2)
  const classes = useStyles();
  const lang = localStorage.getItem('language') || 'Ru'
  const [snackbar, _snackbar] = React.useState([false, '']);
  //const [UserMail, setUserMail] = useState(props.isAuth ? props.usname.email : null);
  const [ModalCallback, _ModalCallback] = React.useState(false);
  let mailTo1 = `mailto:?subject=${mail['subjectShare']}&body=${encodeURIComponent(mail[`bodyShare_${lang}`]) + ' ' + window.location.href}`;
  let mailTo2 = `mailto:${mail['mailto']}?subject=${mail['subjectAppCard']}&body=${encodeURIComponent(mail[`bodyAppCard_${lang}`]) + ' ' + window.location.href}` /* &body=${body1}` */
  let langYEM = lang === 'Ru' ? '/мес.' : '/month';

  let { CodeAsvul, dateendsale1, PaymentOne, PaymentMonthly, paymentcomment1, paymentcommentone1, paymentcommentmonthly1, price1, price2, price3, price4, ResearchMarketMails, price1Com, price2Com, price3Com, IsResearchMarket, setAppBasket, basketChips } = props
  let inCu = props.userCollection.CatalogCu || props.userCollection.inCu;
  if (inCu === '1' && props.app.Currency === 1) {
    inCu = '0'
  } else if (inCu !== '1' && props.app.Currency === 0) {
    inCu = '1'
  }

  const [mails, setMails] = useState(ResearchMarketMails || '') // тут что-то не так. у нас уже есть пропс
  const UserMail = props.isAuth ? props.usname.email : null;
  function closeSnackbar(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    _snackbar([false, '']);
  };

  async function UpPriority() {
    let toJson = ResearchMarketMails.length > 1 ? JSON.parse(ResearchMarketMails) : {}
    toJson[`${UserMail}`] = 1
    setMails(JSON.stringify(toJson))
    const result = await axios.post(`${serverAPI}/uppriority`, { mails: JSON.stringify(toJson), asvul: CodeAsvul })
    // if (result) { 
    //   console.log('result', result);
    // } // codeerr пока заглушка
    // showSnackbar()
  }

  function showSnackbar(type, text) {
    // if (!basketChips.includes(app.ID)) {

    // }
    if (type === 1) {
      _snackbar([true, text]);
      UpPriority();
    } else {
      _snackbar([true, text]);
    }
    // setAppBasket(app)
  }

  function renderPrice2Comment() {
    // Проверка на существование и ненулевые значения
    const hasPrice1 = price1Com && price1Com.length > 0 && price1Com !== '0';
    const hasPrice2 = price2Com && price2Com.length > 0 && price2Com !== '0';
    const hasPrice3 = price3Com && price3Com.length > 0 && price3Com !== 999999 && price3Com !== '0';

    if (hasPrice1 && hasPrice2 && hasPrice3) {
      return (
        <CustomTooltip title={lang === 'Ru' ? 'Особые условия лицензирования' : "Special licensing conditions"}>
          <Typography component="span" className={classes.AppInsideCardTitle4}>***</Typography>
        </CustomTooltip>
      );
    } else if (hasPrice1 && !hasPrice2 && hasPrice3) {
      return (
        <CustomTooltip title={lang === 'Ru' ? 'Особые условия лицензирования' : "Special licensing conditions"}>
          <Typography component="span" className={classes.AppInsideCardTitle4}>**</Typography>
        </CustomTooltip>
      );
    } else if (!hasPrice1 && hasPrice2 && hasPrice3) {
      return (
        <CustomTooltip title={lang === 'Ru' ? 'Особые условия лицензирования' : "Special licensing conditions"}>
          <Typography component="span" className={classes.AppInsideCardTitle4}>**</Typography>
        </CustomTooltip>
      );
    } else if (!hasPrice1 && hasPrice3) {
      return (
        <CustomTooltip title={lang === 'Ru' ? 'Особые условия лицензирования' : "Special licensing conditions"}>
          <Typography component="span" className={classes.AppInsideCardTitle4}>*</Typography>
        </CustomTooltip>
      );
    }

    return null;
  }

  function renderPrice3Comments() {
    // Проверка на существование и ненулевые значения
    const hasPrice1 = price1Com && price1Com.length > 0 && price1Com !== '0';
    const hasPrice2 = price2Com && price2Com.length > 0 && price2Com !== '0';
    const hasPrice3 = price3Com && price3Com.length > 0 && price3Com !== 999999 && price3Com !== '0';

    if (hasPrice1 && hasPrice2 && hasPrice3) {
      return (
        <React.Fragment>
          <Typography className={classes.AppInsideCardCaption3} style={{ color: 'red', width: 16 }}>***</Typography>
          <Typography className={classes.AppInsideCardCaption3} dangerouslySetInnerHTML={{ __html: price3Com }} style={{ width: 'calc(100% - 16px)' }} />
        </React.Fragment>
      );
    } else if (hasPrice1 && !hasPrice2 && hasPrice3) {
      return (
        <React.Fragment>
          <Typography className={classes.AppInsideCardCaption3} style={{ color: 'red', width: 16 }}>**</Typography>
          <Typography className={classes.AppInsideCardCaption3} dangerouslySetInnerHTML={{ __html: price3Com }} style={{ width: 'calc(100% - 16px)' }} />
        </React.Fragment>
      );
    } else if (!hasPrice1 && hasPrice2 && hasPrice3) {
      return (
        <React.Fragment>
          <Typography className={classes.AppInsideCardCaption3} style={{ color: 'red', width: 16 }}>**</Typography>
          <Typography className={classes.AppInsideCardCaption3} dangerouslySetInnerHTML={{ __html: price3Com }} style={{ width: 'calc(100% - 16px)' }} />
        </React.Fragment>
      );
    } else if (!hasPrice1 && !hasPrice2 && hasPrice3) {
      return (
        <React.Fragment>
          <Typography className={classes.AppInsideCardCaption3} style={{ color: 'red', width: 16 }}>*</Typography>
          <Typography className={classes.AppInsideCardCaption3} dangerouslySetInnerHTML={{ __html: price3Com }} style={{ width: 'calc(100% - 16px)' }} />
        </React.Fragment>
      );
    }

    return null;
  }

  /* ЦЕНА ПО АКЦИИ >>>>> */
  function ActionPriceOne() {
    if (price3) {
      if (price3 < price1) {
        return (
          <Grid item style={{ display: 'inline-flex' }}>
            <Typography component="p" className={classes.AppInsideCardTitle4}>
              {price3 + ' ' + utils.getPriceItem(inCu, lang, 'elp')}
            </Typography>
          </Grid>
        )
      }
    }
  }

  function ActionPriceMonthly() {
    if (price4) {
      if (price4 < price2) {
        return (
          <Grid item style={{ display: 'inline-flex' }}>
            <Typography component="p" className={classes.AppInsideCardTitle4}>
              {price4 + ' ' + utils.getPriceItem(inCu, lang, 'lp')}
            </Typography>
          </Grid>
        )
      }
    }
  }
  /* <<<<< ЦЕНА ПО АКЦИИ */

  function PriceCommentELP() {
    return (
      <span>
        {translate.Words[`Price11${lang}`]}
        /
        <br />
        {translate.Words[`Price12${lang}`]}
      </span>
    )
  }

  const renderAppCurrency = (type, condition) => (
    inCu === '1'
      ?
      <CustomTooltip title={<span>
        {translate.Words[`CurrentRate_${lang}`]}
        {/* <br />{translate.Words[`NextRate_${lang}`]} */}
      </span>}>
        <Typography
          component="p"
          style={{ marginLeft: '5px' }}
          // className={classes.AppInsideCardTitle4}>
          className={clsx(classes.Price, {
            [classes.ActionPrice]: condition
          })}
        >
          {utils.getPriceItem(inCu, lang, type)}
        </Typography>
      </CustomTooltip>
      :
      <Typography
        component="p"
        style={{ marginLeft: '5px' }}
        // className={classes.AppInsideCardTitle4}>
        className={clsx(classes.Price, {
          [classes.ActionPrice]: condition
        })}
      >
        {utils.getPriceItem(inCu, lang, type)}
      </Typography>
  )



  const renderFavoritesIcon = (row, isCart, appFavorite, appsInProducts) => {
    let appInFavorite = appFavorite && appFavorite.includes(row.ID);
    let title = appInFavorite ? translate.Words[`RemoveFromFavorite${lang}`] : translate.Words[`AddToFavorite${lang}`];
    let fill = appInFavorite ? '#FFFFFF' : '#BCBBD0';
    let onClick = /*isBasket ?*/ () => { props.saveCollection(row.ID, 'app', 'favorite') };
    let backgroundColor = appInFavorite ? '#EB505E' : '#FFF';
    if (appsInProducts.includes(row.ID)) {
      fill = '#BCBBD0';
      backgroundColor = '#FFF';
      title = translate.Words[`AppIsPartOfProducts_${lang}`];
      onClick = () => { }
    }
    return (
      row.DateEndSale.length > 2 || row.IsResearchMarket.length > 2 || row.isModernSystems === 1
        ?
        null
        :
        <FavoriteButton fill={fill} title={title} onClick={onClick} boxShadow backgroundColor={backgroundColor} />
    )
  }

  const handleModalCallback = () => {
    _ModalCallback(!ModalCallback)
  }

  const renderPriceBlock = () => {
    if (props.isHidePrice === 1) {
      return (
        <Grid item container direction="row" style={{ padding: 0, justifyContent: 'space-between' }}>
          <Grid className={classes.Price1Cntr}>
            <Grid item style={{ display: 'grid' }}>{lang === 'Ru' ? 'По запросу' : 'On request'} </Grid>
          </Grid>
        </Grid>
      )

    } else {
      return (
        <Grid item container direction="row" style={{ padding: 0, justifyContent: 'space-between' }}>
          {
            price1 === null || typeof price1 === 'number' && price1 < 0
              ?
              <Typography className={classes.pricePrimary} style={{ width: '50%' }}>-</Typography>
              :
              <Grid className={classes.Price1Cntr}>
                <Grid item style={{ display: 'grid' }}>
                  {ActionPriceOne()}

                  <Grid item style={{ display: 'inline-flex' }}>
                    <CustomTooltip title={PriceCommentELP()}>
                      <Typography
                        component="p"
                        className={clsx(classes.Price, {
                          [classes.ActionPrice]: +price3 > 0 && +price3 < +price1
                        })}
                      >
                        {
                          price1 !== 0
                            ?
                            parseFloat(price1).toLocaleString('ru-RU', { maximumFractionDigits: 3 }) :
                            translate.Words[`NotCharged${lang}`]

                        }
                      </Typography>
                    </CustomTooltip>

                    {
                      price1 !== 0
                        ?
                        renderAppCurrency('elp', +price3 > 0 && +price3 < +price1)
                        :
                        null
                    }
                    <Typography className={classes.AppInsideCardTitle4}>{props.paymentcommentone1}</Typography>
                  </Grid>
                </Grid>
              </Grid>
          }
          {
            price2 === null || typeof price2 === 'number' && price2 < 0
              ?
              <Typography className={classes.pricePrimary} style={{ width: '50%' }}>-</Typography>
              :

              <Grid className={classes.Price2Cntr}>
                <Grid item style={{ display: 'grid' }}>
                  {ActionPriceMonthly()}

                  <Grid item style={{ display: 'inline-flex' }}>
                    <CustomTooltip title={translate.Words[`Price2${lang}`]}>
                      <Typography component="p"
                        // className={classes.AppInsideCardTitle4}>
                        className={clsx(classes.Price, {
                          [classes.ActionPrice]: +price4 > 0 && +price4 < +price2
                        })}
                      >
                        {
                          price2 !== 0
                            ?
                            price2.toLocaleString('ru-RU', { maximumFractionDigits: 3 }) //+ ' ' + utils.getPriceItem(inCu, lang, 'lp') 
                            :
                            translate.Words[`NotCharged${lang}`]
                        }
                      </Typography>
                    </CustomTooltip>

                    {
                      price2 !== 0
                        ?
                        renderAppCurrency('lp', +price4 > 0 && +price4 < +price2)
                        :
                        null
                    }


                    {/* <CustomTooltip title={lang === 'Ru' ? 'Особые условия лицензирования' : "Special licensing conditions"}> */}
                    {renderPrice2Comment()}
                    {/* <Typography component="span" className={classes.AppInsideCardTitle4}>{paymentcommentmonthly1}</Typography> */}
                    {/* </CustomTooltip> */}
                  </Grid>
                </Grid>
              </Grid>
          }
        </Grid>

      )
    }
  }

  const renderCardButton = (appBasket, appsInProducts) => {
    let appInBasket = appBasket.includes(props.asvul.ID);
    let title = appInBasket ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`];
    let tooltip = ''
    let fill = '#FFFFFF';
    let disButton = false;
    let onClick = /*isBasket ?*/ () => { props.saveCollection(props.asvul.ID, 'app', 'cart'); };
    if (appsInProducts.includes(props.asvul.ID)) {
      fill = '#BCBBD0';
      disButton = true;
      title = translate.Words[`RemoveFromBasket${lang}`];
      tooltip = translate.Words[`AppIsPartOfProducts_${lang}`];
      onClick = () => { }
    }
    return (
      <CustomTooltip title={tooltip}>
        <span style={{ width: '100%' }}>
          <CardButton
            disabled={disButton}
            text={title}
            color={fill}
            bgcolor={'#EB505E'}
            shadow={'0px 6px 24px rgba(235, 80, 94, 0.4)'}
            func={onClick}
          />
        </span>
      </CustomTooltip>
    )
  }

  const copyToClipboard = async () => {
    try {
      const permissions = await navigator.permissions.query({ name: "clipboard-write" })
      if (permissions.state === "granted" || permissions.state === "prompt") {
        await navigator.clipboard.writeText(mail[`linkShare_${lang}`] + ' ' + window.location.href);
        showSnackbar(2, translate.Words[`CopiedToClipboard_${lang}`]);
      } else {
        showSnackbar(2, translate.Words[`NotAccessClipboard_${lang}`]);
      }
    } catch (error) {
      showSnackbar(2, translate.Words[`ErrorCopyingClipboard_${lang}`] + error);
    };

    window.location.href = mailTo1;
  };

  return (
    <Card className={classes.root}>
      <CardContent className={classes.CardContent}>
        <Grid
          container
          direction="column"
          justify="space-between"
          //id={'test-data-ready'}
        >
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid>
              {/* SWITCH перенесён на второй этап */}
              <Grid xs={12}>
                {PaymentOne === 999999 || PaymentMonthly === 999999 || PaymentOne <= 0 || PaymentMonthly <= 0 ? '' :
                  IsResearchMarket === '1'
                    ?
                    <Typography component="p" className={classes.Title3} style={{ fontSize: '22px', letterSpacing: '-0.005em' }}> {translate.Words[`PlannedPrice${lang}`]}  {paymentcomment1}</Typography>
                    :
                    <CustomTooltip title={paymentcomment1 !== '*' ? '' : lang === 'Ru' ? 'Особые условия лицензирования' :
                      "Special licensing conditions"}>
                      <Typography component="p" className={classes.Title3}>{translate.Words[`Price${lang}`]}{paymentcomment1}</Typography>
                    </CustomTooltip>
                }
                {/* <Typography component="p" className={classes.Title3}> */}
                {/* {
                dateendsale1 && dateendsale1.length > 2 ? '' :
                  IsResearchMarket == '1' || IsResearchMarket === 1 ?
                  font-size: 22px
                  letter-spacing: -0.005em;
                  
                  
                  */}

                {/* {PaymentOne === 999999 || PaymentMonthly === 999999 ? '' :
                    IsResearchMarket == '1' ?
                      `Предполагаемая цена ${paymentcomment1}`
                      : `Цена ${paymentcomment1}`}
                </Typography> */}
              </Grid>
            </Grid>

            <Grid item>
              {renderFavoritesIcon(props.app, false, props.userCollection.appFavorite, props.userCollection.appFavoriteInProduct)}

              <CustomTooltip title={translate.Words[`ShareLink_${lang}`]}>
                <CustomIconButton aria-label={translate.Words[`ShareLink_${lang}`]} onClick={() => copyToClipboard()}>
                  <ShareIcon fill='#BCBBD0' />
                </CustomIconButton>
              </CustomTooltip>

              <HtmlTooltip
                interactive
                title={
                  !props.isAuth
                    ?
                    lang === 'Ru'
                      ?
                      <Grid item style={{ fontSize: '14px !important' }}><a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Авторизуйтесь</a>, чтобы отправить сообщение</Grid>
                      :
                      <Grid item style={{ fontSize: '14px !important' }}>Please <a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Log in</a> to send message</Grid>
                    :
                    <Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`RequestACallback${lang}`]}</Grid>
                }
              >
                <span style={{ display: 'inline-block' }}>
                  <CustomIconButton disabled={!props.isAuth} aria-label="delete" onClick={() => handleModalCallback()}>
                    <InCallIcon fill='#BCBBD0' />
                  </CustomIconButton>
                </span>
              </HtmlTooltip>
            </Grid>
          </Grid>

          <Grid container direction="row">
            <Grid container xl={12} lg={6} md={6} className={classes.PriceCntr}>
              <Grid item container direction="row"> {/* 0 || -1 цена при приоритетах разработки */}
                {IsResearchMarket === 1 && +price1 == - 1 && false
                  ?
                  <Typography className={classes.pricePrimary} style={{ width: '50%' }}>-</Typography>
                  :
                  null
                }

                {IsResearchMarket === 1 && +price2 == -1 && false
                  ?
                  <Typography className={classes.pricePrimary} style={{ width: '50%' }}>-</Typography>
                  :
                  null
                }
              </Grid>

              <Grid item container style={{ marginTop: 41, display: 'inline-flex' }}>
                {
                  renderPriceBlock()
                }

                {IsResearchMarket === 1 ?
                  <Typography component="p" style={{ marginTop: 8 }}>{translate.Words[`Warning${lang}`]}</Typography>
                  : ''
                }
              </Grid>

              {
                IsResearchMarket || (price1 === 0 && price2 === 0 && price3 === 0 && price4 === 0)
                  ?
                  ''
                  :
                  <Grid style={{ marginTop: 15 }}>
                    <Typography component="a" href='https://www.cft.ru/price' target='_blank' className={classes.LinkType2}>
                      {translate.Words[`AllPlans${lang}`]}
                    </Typography>
                  </Grid>
              }

              <Grid container style={{ maxWidth: '80%' }}>
                <KloStatus kloUser={props.kloUser} kloStatus={props.kloStatus} codeasvul={CodeAsvul} isApp={true} />
              </Grid>
            </Grid>

            {/* ===== ОТЛОЖЕНО НА ЭТАП 2 ================
              {IsResearchMarket ? '' :
                <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  alignItems="center"
                  style={{ marginTop: 32 }}
                >
                  <FormControlLabel
                    className={classes.formControl}
                    // value={index}
                    control={<CustomCheckboxWhite />}
                    label={<Typography className={classes.label} style={{ marginRight: 16 }}>Добавить зависисмости</Typography>}
                    labelPlacement="end"
                  />
                  <CustomTooltip title={lang === 'Ru' ? "Приложения, необходимые для работы выбранного" : "Add Applications that this Application depends on"}>
                    <HintIcon fill={'#4C85FF'} />
                  </CustomTooltip>
                </Grid>
              }
              ================ ОТЛОЖЕНО НА ЭТАП 2 =====
              */}

            <Grid container style={{ maxWidth: '80%' }}>
              <KloStatus kloUser={props.kloUser} kloStatus={props.kloStatus} codeasvul={CodeAsvul} isApp={true} />

              {/* <Typography style={{ color: '#7D62BA', fontSize: '13px', lineHeight: '16px' }}>“Современные Системы”</Typography> */}
            </Grid>

            <Grid container xl={12} lg={6} md={6} className={classes.ActionCntr}>
              {dateendsale1 && dateendsale1.length > 2 ? '' :
                IsResearchMarket === 1
                  ?
                  <HtmlTooltip
                    interactive
                    title={
                      UserMail === null
                        ?
                        lang === 'Ru'
                          ?
                          <Grid item style={{ fontSize: '14px !important' }}><a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Авторизуйтесь</a>, чтобы повысить приоритет </Grid>
                          :
                          <Grid item style={{ fontSize: '14px !important' }}>Please <a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Log in</a> to raise priority </Grid>
                        :
                        mails.includes(UserMail)
                          ?
                          <Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`YourVoteHasBeenRegistered${lang}`]} </Grid>
                          :
                          <Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`ClickToIncreasePriority${lang}`]} </Grid>
                    }
                  >
                    <Grid item container style={{ margin: '32px 0 0', paddingBottom: 24 }}>
                      <CardButton
                        text={mails.includes(UserMail) ? translate.Words[`Prioritized${lang}`] : translate.Words[`Prioritize${lang}`]}
                        bgcolor={'#8094FF'}
                        hbgcolor={'#5D75F8'}
                        shadow={'0px 6px 24px rgba(128, 148, 255, 0.4)'}
                        color={UserMail === null ? 'rgba(0, 0, 0, 0.26)' : mails.includes(UserMail) ? '#3C3C56' : '#FFFFFF'}
                        discolor={mails.includes(UserMail) ? '#3C3C56 !important' : null}
                        disbgcolor={mails.includes(UserMail) ? '#EEEEF5 !important' : null}
                        icon={mails.includes(UserMail) ? null : 2}
                        // func={() => UpPriority()}
                        func={() => showSnackbar(1, translate.Words[`HasBeenRaised${lang}`])}
                        disabled={UserMail === null ? true : mails.includes(UserMail)}
                      />
                    </Grid>
                  </HtmlTooltip>
                  :
                  renderCardButton(props.userCollection.appBasket, props.userCollection.appCartInProduct)
              }
            </Grid>
          </Grid>
        </Grid>

        {
          price1Com && price1Com.length > 0 && price1Com !== '0'
            ?
            <Grid item container id='paymentComment' style={{ marginTop: 32 }}>
              <Typography className={classes.AppInsideCardCaption3} dangerouslySetInnerHTML={{ __html: paymentcomment1 }} style={{ color: 'red', width: 16 }} />
              <Typography className={classes.AppInsideCardCaption3} dangerouslySetInnerHTML={{ __html: price1Com }} style={{ width: 'calc(100% - 16px)' }} />
            </Grid>
            :
            ''
        }

        {
          price2Com && price2Com.length > 0 && price2Com !== '0' && props.isHidePrice !== 1
            ?
            <Grid item container id='paymentCommentOne' style={{ marginTop: 12 }}>
              <Typography className={classes.AppInsideCardCaption3} dangerouslySetInnerHTML={{ __html: paymentcommentone1 }} style={{ color: 'red', width: 16 }} />
              <Typography className={classes.AppInsideCardCaption3} dangerouslySetInnerHTML={{ __html: price2Com }} style={{ width: 'calc(100% - 16px)' }} />
            </Grid>
            :
            ''
        }

        {
          price3Com && price3Com.length > 0 && price3Com !== 999999 && price3Com !== '0' && props.isHidePrice !== 1
            ?
            <Grid item container id='paymentCommentMonthly' style={{ marginTop: 12 }}>
              {renderPrice3Comments()}
              {/* <Typography className={classes.AppInsideCardCaption3} dangerouslySetInnerHTML={{ __html: paymentcommentmonthly1 }} style={{ color: 'red', width: 16 }} /> */}
              {/* <Typography className={classes.AppInsideCardCaption3} dangerouslySetInnerHTML={{ __html: price3Com }} style={{ width: 'calc(100% - 16px)' }} /> */}
            </Grid>
            :
            ''
        }

        <AbortRecall
          isAuth={props.isAuth}
          usname={props.usname}
          setIsAuth={props.setIsAuth}
          ModalCallback={ModalCallback}
          setModalCallback={_ModalCallback}
          submit={'callback'}
          appID={props.asvul.ID}
        />
      </CardContent>

      {/* <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions> */}

      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={snackbar[0]}
          autoHideDuration={3000}
          onClose={closeSnackbar}
        // message="Приложение доавлено в корзину"
        // className={classes.root}
        >
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            className={classes.snackbarPostroot}
          >
            <Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
              </svg>
            </Avatar>

            <Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>{snackbar[1]}</Typography>
          </Grid>
        </Snackbar>
      </div>
    </Card >
  );
}

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.87)',
    color: 'rgba(255, 255, 255, 0.87)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    borderRadius: '8px',
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 400,
    padding: 12,
    opacity: 0.5,

    '& a': {
      color: 'rgba(255, 255, 255, 0.87)',
    }
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '100%',
    backgroundColor: '#F6F6FB',
    borderRadius: 16,
    boxShadow: 'none',
    padding: 24,
    height: 'fit-content',

    [theme.breakpoints.down(696)]: {
      padding: 0,
      backgroundColor: 'transparent',
    }
  },

  CardContent: {
    [theme.breakpoints.down(696)]: {
      padding: 0,
      paddingBottom: 0
    }
  },

  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },

  title: {
    fontSize: 14,
  },

  pos: {
    marginBottom: 12,
  },

  AppInsideCardCaption1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '16px',
    color: '#93919B',

    '& * > a': {
      color: '#24262A !important',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

      '&:hover': {
        color: '#2050FF !important',
        textDecoration: 'none',
        borderBottom: '1px solid #2050FF',
      }
    },
  },

  AppInsideCardCaption2: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#8987A2',

    '& * > a': {
      color: '#24262A !important',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

      '&:hover': {
        color: '#2050FF !important',
        textDecoration: 'none',
        borderBottom: '1px solid #2050FF',
      }
    },
  },

  AppInsideCardCaption4: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '25px',
    color: '#24262A',
    opacity: 0.4,

    '& * > a': {
      color: '#24262A !important',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

      '&:hover': {
        color: '#2050FF !important',
        textDecoration: 'none',
        borderBottom: '1px solid #2050FF',
      }
    },
  },

  AppInsideCardTitle4: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  AppInsideCardBody2: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#8987A2'
  },

  LinkType2: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: '#8987A2',
    textDecoration: 'none',

    '&:hover': {
      color: '#24262A',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
    }
  },

  formControl: {
    height: 40,
    marginRight: 0
  },

  Title3: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '24px',
    lineHeight: '32px',
    color: '#000000'
  },

  Price1Cntr: {
    display: 'inline-flex',
  },

  Price: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  ActionPrice: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A',
    opacity: '0.4',
    textDecoration: 'line-through'
  },

  Price2Cntr: {
    display: 'inline-flex',

    [theme.breakpoints.down(696)]: {
      marginLeft: 0,
    }
  },

  AppInsideCardCaption3: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    // color: '#8987A2',
    color: 'black',

    '& > p': {
      '&:first-child': {
        marginTop: 0
      }
    },

    '& * > a': {
      color: '#24262A !important',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

      '&:hover': {
        color: '#2050FF !important',
        textDecoration: 'none',
        borderBottom: '1px solid #2050FF',
      }
    },

    // '& > p': {
    //   '&:before': {
    //     content: '"*"',
    //     color: 'red',
    //     paddingRight: 4
    //   },
    // }
  },

  ActionCntr: {
    [theme.breakpoints.between(696, 1032)]: {
      maxWidth: 340,
      margin: 'auto'
    },

    [theme.breakpoints.down(696)]: {
      maxWidth: "unset",
      paddingRight: 0,
      margin: "unset"
    },
  },

  PriceCntr: {
    margin: 0,
    paddingBottom: 24,

    // [theme.breakpoints.between(1032, 1702)]: {
    //   paddingRight: 32,
    // },

    [theme.breakpoints.between(696, 1032)]: {
      maxWidth: 340,
      margin: 'auto'
    },

    [theme.breakpoints.down(696)]: {
      maxWidth: "unset",
      paddingRight: 0,
      margin: "unset"
    },
  },

  snackbarPostroot: {
    padding: 24,
    borderRadius: '16px',
    background: 'rgba(60, 60, 86, 0.9)',
  },
}));